export const CupIcon = () => {
  return (
<svg
   width="24"
   height="24"
   viewBox="0 0 24 24"
   fill="none"
   stroke="currentColor"
   strokeWidth="2"
   strokeLinecap="round"
   strokeLinejoin="round"
   id="svg4"
   xmlns="http://www.w3.org/2000/svg">
  <defs
     id="defs4" />
  <path
     d="M 6.0926186,4.9319043 7.8156048,19.821805 a 1.9691271,2.4250652 0 0 0 1.9691272,2.085556 h 4.469919 a 1.9691271,2.4250652 0 0 0 1.969127,-2.085556 L 17.907381,4.9319043"
     id="path1"/>
  <path
     d="M 5,4 H 19"
     id="path2" />
  <path
     d="M 7.1808036,12.625 H 16.962054"
     id="path3" />
</svg>
)};
